'use client';

import styled from 'styled-components';

export const StyledCredentialCard = styled.div`
  > span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;
    padding-left: 8px;

    .required {
      color: #ff0000 !important;
      padding-left: 0;
    }
  }

  .cc-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;

      .required {
        color: #ff0000 !important;
        padding-left: 0;
      }
    }
  }
`;

export const StyledCredentialCardTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCredentialCardTableHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-off-white);
  border-top: 1px solid var(--color-pale-gray);

  > div {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    padding: 11px 0;

    &:first-of-type {
      width: 140px;
    }

    &:nth-of-type(2) {
      width: 210px;
    }

    &:last-of-type {
      width: 170px;
    }
  }
`;

export const StyledCredentialCardTableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCredentialCardTableRow = styled.div`
  display: flex;
  align-items: center;

  &:nth-child(odd) {
    border-top: 1px solid var(--color-pale-gray);
    border-bottom: 1px solid var(--color-pale-gray);
  }

  .row {
    text-align: center;
    padding: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: var(--color-medium-gray);

    > div {
      margin-bottom: 0;

      > .datePickerWrapper {
        border-radius: 4px;
        height: 36px !important;
        /* overflow: hidden; */
      }
    }
  }

  .required {
    font-size: 14px;
    font-weight: 600;
    color: rgb(222, 62, 71) !important;
    padding-left: 0;
  }

  .type {
    width: 130px;

    > p {
      > span {
        .required {
          color: red;
          padding-left: 0;
        }
      }
    }
  }

  .number {
    width: 200px;
  }

  .date {
    width: 170px;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
